<script>
    import http from "@/http";
    import { mapGetters } from "vuex";

    export default {
        data: () => ({
            open: false,
            loading: false,

            r: {
                nome: '',
                cnpj: ''
            }
        }),

        methods: {
            handleSubmit() {
                this.loading = true

                const cnpj = this.r.cnpj.replace(/[^\d]+/g, "")

                http.post("/requisicoes", {
                    type: 1,
                    nome: this.r.nome,
                    user: {
                        id: this.user.id,
                        email: this.user.email,
                        nome: this.user.pessoa.nome
                    },
                    cnpj
                })
                    .then(r => {

                        this.r = {
                            nome: "",
                            cnpj: "",
                        };
                    })
                    .catch(e => {
                        console.log(e);
                    })
                    .finally(() => {
                        this.loading = false;
                        this.open = false;
                    })
            }
        },

        computed: {
            ...mapGetters(["user"])
        }
    };
</script>

<template>
    <section>
        <v-dialog v-model='open' max-width='600px'>
            <template v-slot:activator='{ on }'>
                <v-btn flat icon v-on='on'>
                    <v-icon aria-hidden='true'>playlist_add</v-icon>
                </v-btn>
            </template>
            <form @submit.prevent="handleSubmit">
                <v-card>
                    <v-card-title>
                        <span class='headline'>Solicitar Nova Empresa</span>
                    </v-card-title>
                    <v-card-text>
                        <section style='padding: 5px'>
                            <v-text-field
                                :disabled="loading"
                                v-model="r.nome"
                                label='Nome Fantasia'
                                required
                            />
                            <v-text-field
                                :disabled="loading"
                                v-model="r.cnpj"
                                label='CNPJ'
                                required
                            />
                        </section>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color='primary'
                            :disabled="loading"
                            flat
                            @click='open = false'
                        >
                            Cancelar
                        </v-btn>
                        <v-btn color='primary'
                            :disabled="loading"
                            type="submit"
                        >
                            Solicitar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-dialog>
    </section>
</template>

